import axios from "axios";
const jwt = require("jwt-simple");
const baseUrl = "http://localhost:5050"; //"https://api.brevitybuilder.com";

export default async function fn({ appId, version, method, url, body, user = {} }) {
  const isExp = (token) => {
    let t = jwt.decode(token, "", true);
    return (t.exp - Number.parseInt((Date.now()/1000).toFixed()) < 5);
  }

  if (!user.jwt || isExp(user.jwt)) {
    let token = await user.refreshToken();
    user = { jwt: token };
  }

  return new Promise(async (resolve, reject) => { 
    axios.defaults.headers.common["Authorization"] = `Bearer ${user.jwt}`;
    let req;
  
    if (method === "get" || method === "delete") {
      req = axios[method](`${baseUrl}/app/${appId}/${version}/admin/${url}`);
    } else if (method === "post" || method === "patch") {
      req = axios[method](
        `${baseUrl}/app/${appId}/${version}/admin/${url}`,
        body
      );
    }
  
    req
      .then((result) => {
        if (result.status === 200) resolve(result);
        else throw new Error(result);
      })
      .catch((err) => {
        if (!err || !err.response) err = { response: { status: 400, data: null }};
        const status = err.response.status ? err.response.status : 400;
        let error; 
        if (status === 401) error = "unauthenticated";
        else if (status === 403) {
          error = "unauthorized";
        }
        else error = "invalid-argument";
        reject({
          err: {
            details: error,
            status: status,
            ...err.response.data,
          },
        });
      });
  });
}
